
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.749 7.517c-.262 0-.5-.133-.638-.356s-.15-.495-.033-.73l2.594-5.188c.175-.35.439-.65.765-.866a2.24 2.24 0 011.69-.334c.59.118 1.098.459 1.431.959l.751 1.128.452-.433c.161-.161.354-.3.569-.407a2.229 2.229 0 011.005-.239c.859 0 1.63.476 2.014 1.242l2.069 4.139a.746.746 0 01-.032.729.745.745 0 01-.638.356H.749zm10.786-1.5l-1.526-3.053A.747.747 0 008.81 2.77l-.657.629a.75.75 0 01-1.278.784l-.288-.432a.654.654 0 01-.059-.089L5.309 1.834a.748.748 0 00-1.295.08L1.963 6.017h9.572zM20.249 15a.75.75 0 01-.75-.75V12h-2.25a.753.753 0 01-.706-1.006l3-8.25c.108-.295.391-.494.705-.494s.597.198.705.494l3 8.25A.748.748 0 0123.249 12h-2.25v2.25a.75.75 0 01-.75.75zm1.929-4.5l-1.929-5.305L18.32 10.5h3.858zM3.749 24a.75.75 0 01-.75-.75V21H.749a.75.75 0 01-.704-1.007l3-8.25a.752.752 0 011.41 0l3 8.25A.753.753 0 016.749 21h-2.25v2.25a.75.75 0 01-.75.75zm1.929-4.5l-1.929-5.305L1.82 19.5h3.858zM20.769 22.506a.747.747 0 01-.717-.528 4.067 4.067 0 00-1.073-1.736.751.751 0 011.038-1.083 5.578 5.578 0 011.468 2.376.75.75 0 01-.716.971zM17.255 19.126a.736.736 0 01-.242-.04 8.502 8.502 0 00-1.385-.346c-.273-.045-.544-.1-.805-.163a.75.75 0 01.352-1.458c.227.055.46.102.696.141.548.089 1.096.225 1.626.406a.751.751 0 01-.242 1.46zM11.999 17.117a.748.748 0 01-.5-.191 6.464 6.464 0 01-1.47-1.922.746.746 0 01.333-1.007.749.749 0 011.006.333 4.995 4.995 0 001.13 1.479.741.741 0 01.248.518.746.746 0 01-.747.79zM9.836 12.25a.749.749 0 01-.746-.673 17.446 17.446 0 01-.091-1.829.751.751 0 011.5.004c-.002.555.026 1.117.083 1.671a.751.751 0 01-.746.827z"}})])
          )
        }
      }
    